import React from 'react';
import { useMsal } from '@azure/msal-react';
import styled from 'styled-components';

const SignInButton = () => {
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginPopup({
      scopes: ["User.Read", "GroupMember.Read.All"]
    });
  };

  return (
    <StyledButton onClick={handleSignIn}>
      Sign In with Microsoft
    </StyledButton>
  );
};

const StyledButton = styled.button`
  background: #0078d4;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #106ebe;
  }

  &:active {
    background: #005a9e;
  }
`;

export default SignInButton;
